import { createSlice } from '@reduxjs/toolkit';
import {
    TS_HoSoThiSinh_ViewModel,
    TS_TongHopThiSinhDanhKyTheoMon,
    TS_TongHopThiSinhDanhKyTheoNganh
} from '../../services/ho-so-thi-sinh/HoSoThiSinhModels';

interface DanhSachThiSinhDangKyState {
    isShowCreateOrEditModal: boolean;
    isShowConfirmDeleteModal: boolean;
    createOrEditModel: TS_HoSoThiSinh_ViewModel | undefined;
    status: string;
    listData: TS_HoSoThiSinh_ViewModel[];
    listDataGroupMon: TS_TongHopThiSinhDanhKyTheoMon[];
    listDataGroupNganh: TS_TongHopThiSinhDanhKyTheoNganh[];
    selectedId: number | null;
    selectedIDDotTS: number | null;
}

const initialState: DanhSachThiSinhDangKyState = {
    isShowCreateOrEditModal: false,
    isShowConfirmDeleteModal: false,
    createOrEditModel: undefined,
    status: 'loading',
    selectedId: null,
    selectedIDDotTS: null,
    listData: [],
    listDataGroupMon: [],
    listDataGroupNganh: []
};

const DanhSachThiSinhDangKySlice = createSlice({
    name: 'DanhSachThiSinhDangKy',
    initialState,
    reducers: {
        updateDanhSachThiSinhDangKySuccess: (state, action) => {
            const updatedDanhSachThiSinhDangKy = action.payload;

            const index = state.listData.findIndex(
                (DanhSachThiSinhDangKy) =>
                    DanhSachThiSinhDangKy.ID_thi_sinh === updatedDanhSachThiSinhDangKy.ID_thi_sinh
            );
            console.log('updateDanhSachThiSinhDangKySuccess', updatedDanhSachThiSinhDangKy, index);
            if (index !== -1) {
                state.listData[index] = updatedDanhSachThiSinhDangKy;
            }
            state.isShowCreateOrEditModal = false;
        },
        deleteDanhSachThiSinhDangKySuccess: (state, action) => {
            const idToDelete = action.payload;
            state.listData = state.listData.filter(
                (DanhSachThiSinhDangKy) => DanhSachThiSinhDangKy.ID_thi_sinh !== idToDelete
            );
            state.isShowConfirmDeleteModal = false;
        },
        insertDanhSachThiSinhDangKySuccess: (state, action) => {
            const newDanhSachThiSinhDangKy = action.payload;
            state.listData.push(newDanhSachThiSinhDangKy);
            state.isShowCreateOrEditModal = false;
        },
        selectDanhSachThiSinhDangKy: (state, action) => {
            state.selectedId = action.payload;
        },
        clearSelectedDanhSachThiSinhDangKy: (state) => {
            state.selectedId = null;
        },
        resetDanhSachThiSinhDangKyState: (state) => {
            state.isShowCreateOrEditModal = initialState.isShowCreateOrEditModal;
            state.createOrEditModel = initialState.createOrEditModel;
            state.status = initialState.status;
            state.listData = initialState.listData;
            state.selectedId = initialState.selectedId;
        },
        setDanhSachThiSinhDangKyList: (state, action) => {
            state.listData = action.payload;
        },
        setTongHopThiSinhDangKyTheoMon: (state, action) => {
            state.listDataGroupMon = action.payload;
        },
        setTongHopThiSinhDangKyTheoNganh: (state, action) => {
            state.listDataGroupNganh = action.payload;
        },
        setDanhSachThiSinhDangKyStatus: (state, action) => {
            state.status = action.payload;
        },
        setDanhSachThiSinhDangKyCreateOrEditModel: (state, action) => {
            state.createOrEditModel = action.payload;
        },
        setDanhSachThiSinhDangKyShowCreateOrEditModal: (state, action) => {
            state.isShowCreateOrEditModal = action.payload;
        },
        setDanhSachThiSinhDangKySelectedId: (state, action) => {
            state.selectedId = action.payload;
        },
        setDanhSachThiSinhDangKyShowConfirmDeleteModal: (state, action) => {
            state.isShowConfirmDeleteModal = !state.isShowConfirmDeleteModal;
            state.selectedId = action.payload;
        },
        setIDDotTS: (state, action) => {
            state.selectedIDDotTS = action.payload;
        }
    }
});

export const {
    clearSelectedDanhSachThiSinhDangKy,
    deleteDanhSachThiSinhDangKySuccess,
    insertDanhSachThiSinhDangKySuccess,
    resetDanhSachThiSinhDangKyState,
    selectDanhSachThiSinhDangKy,
    setDanhSachThiSinhDangKyCreateOrEditModel,
    setDanhSachThiSinhDangKyList,
    setTongHopThiSinhDangKyTheoMon,
    setTongHopThiSinhDangKyTheoNganh,
    setDanhSachThiSinhDangKySelectedId,
    setDanhSachThiSinhDangKyShowCreateOrEditModal,
    setDanhSachThiSinhDangKyStatus,
    updateDanhSachThiSinhDangKySuccess,
    setDanhSachThiSinhDangKyShowConfirmDeleteModal,
    setIDDotTS
} = DanhSachThiSinhDangKySlice.actions;

export const DanhSachThiSinhDangKyReducer = DanhSachThiSinhDangKySlice.reducer;
